import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Edit from '@mui/icons-material/Edit';
import { updateClientAddress } from 'src/store/actions/clientActions';
import AddressDialog from 'src/components/AddressDialog/AddressDialog';
import AddressDetailBox from 'src/components/AddressDetailBox/AddressDetailBox';
import useStyles from '../styles';

const ClientAddress = ({ address, addressName, client }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleSubmit = useCallback(
    values => {
      const updatedValues = {
        ...values,
        addressType: address.addressType
      };
      dispatch(updateClientAddress(id, updatedValues, () => handleClose()));
    },
    [address, dispatch]
  );

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {addressName}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <AddressDetailBox
              address={address}
              includeProofOfAddress
              documentData={{
                documents: client.documents,
                id: client.id
              }}
            />
          </TableBody>
        </Table>
        <AddressDialog
          open={open}
          address={address}
          handleClose={handleClose}
          submit={handleSubmit}
        />

        <Grid container direction="column" alignItems="stretch">
          <Grid item className={classes.buttons}>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              color="primary"
              className={clsx(classes.label, classes.buttons)}
              startIcon={<Edit />}
            >
              {t('COMMON.EDIT')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ClientAddress.propTypes = {
  address: PropTypes.object.isRequired,
  addressName: PropTypes.string.isRequired,
  client: PropTypes.object.isRequired
};

export default ClientAddress;
